var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { NodeSelection } from 'prosemirror-state';
import { EventChannel } from '../event';
import { defineMetadata, getMetadata } from '../libs';
import { FLAG, FORMAT_TYPE, META, SELECT_CLS, SYL_TAG } from './const';
import { Atom, BlockAtom, InlineAtom, SchemaMeta } from './schema';
import { createCardDOM, createInlineCardDOM, createMaskDOM, createTemplDOM, createWrapperDOM, isCardSchema, isInlineSchema, } from './utils';
var createCursorFixer = function () {
    var dom = document.createElement('span');
    dom.className = 'syl-inline-fixer';
    dom.appendChild(document.createTextNode('\u200B'));
    return dom;
};
// define all of the basic property of nodeView
var BaseCardView = /** @class */ (function () {
    function BaseCardView(adapter, node, view, getPos) {
        var _this = this;
        this.dom = document.createElement('span');
        this.template = createTemplDOM();
        this.mask = createMaskDOM();
        this.isSelected = false;
        this.traceSelection = true;
        this.renderer = null;
        this.traceSelect = function () {
            var selection = _this.adapter.view.state.selection;
            if (selection instanceof NodeSelection)
                return;
            if (selection.empty && _this.isSelected) {
                _this.deselectNode();
            }
            else {
                var pos = _this.getPos();
                var from = selection.from, to = selection.to;
                if (from <= pos && pos < to) {
                    !_this.isSelected && _this.selectNode();
                }
                else if (_this.isSelected) {
                    _this.deselectNode();
                }
            }
        };
        this.getNode = function () { return _this.adapter.view.state.tr.doc.nodeAt(_this.getPos()); };
        this.attrs = node.attrs;
        this.adapter = adapter;
        this.getPos = getPos;
        this.dom.setAttribute(SYL_TAG, 'true');
        this.traceSelection = !(node.type.spec.traceSelection === false);
        if (this.traceSelection) {
            this.adapter.on(EventChannel.LocalEvent.SELECTION_CHANGED, this.traceSelect);
        }
    }
    BaseCardView.prototype.update = function (_a) {
        var attrs = _a.attrs, isSelected = _a.isSelected, isText = _a.isText;
        // do update attrs
        return false;
    };
    BaseCardView.prototype.selectNode = function () {
        var currentNode = this.getNode();
        if (currentNode)
            this.attrs = currentNode.attrs;
        this.update({
            attrs: this.attrs,
            isSelected: true,
        });
        this.isSelected = true;
        this.dom.classList.add(SELECT_CLS);
        return false;
    };
    BaseCardView.prototype.deselectNode = function () {
        // if attrs are modified from selectNode to deselectNode, but without calling dispatchUpdate, deselectNode will reset the updated attrs
        var currentNode = this.getNode();
        if (currentNode)
            this.attrs = currentNode.attrs;
        this.update({
            attrs: this.attrs,
            isSelected: false,
        });
        this.isSelected = false;
        this.dom.classList.remove(SELECT_CLS);
        return;
    };
    BaseCardView.prototype.mount = function (_a) {
        var ViewMap = _a.ViewMap, layers = _a.layers;
        console.error('[SylEditor Warning]: this error usually means you do not' +
            'import Card/InlineCard from access layer' +
            'do not import from @syllepsis/cadapter directly');
    };
    BaseCardView.prototype.afterMount = function (name) {
        this.fixCursor(name);
        this.dom.appendChild(this.template);
        this.dom.appendChild(this.mask);
    };
    BaseCardView.prototype.fixCursor = function (name) {
        var curNode = this.adapter.view.state.schema.nodes[name];
        if (!curNode || !curNode.spec.fixCursor)
            return;
        this.dom.insertBefore(createCursorFixer(), this.dom.firstElementChild);
        this.dom.appendChild(createCursorFixer());
    };
    // cardDOM position relative to editor.root
    BaseCardView.prototype.getBoundingClientRect = function () {
        var domRect = this.dom.getBoundingClientRect();
        var rootRect = this.adapter.root.getBoundingClientRect();
        return __assign(__assign({}, JSON.parse(JSON.stringify(domRect))), { top: domRect.top - rootRect.top, left: domRect.left - rootRect.left, bottom: domRect.bottom - rootRect.top, right: domRect.right - rootRect.left });
    };
    BaseCardView.prototype.dispatchUpdate = function (attrs) {
        var view = this.adapter.view;
        // update attrs
        this.attrs = attrs;
        view.dispatch(view.state.tr.setNodeMarkup(this.getPos(), undefined, attrs));
    };
    BaseCardView.prototype.ignoreMutation = function (event) {
        // return true
    };
    BaseCardView.prototype.stopEvent = function () {
        // return true
    };
    BaseCardView.prototype.destroy = function () {
        if (this.traceSelection) {
            this.adapter.off(EventChannel.LocalEvent.SELECTION_CHANGED, this.traceSelect);
        }
    };
    return BaseCardView;
}());
var BlockCardView = /** @class */ (function (_super) {
    __extends(BlockCardView, _super);
    function BlockCardView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dom = createCardDOM();
        return _this;
    }
    return BlockCardView;
}(BaseCardView));
var InlineCardView = /** @class */ (function (_super) {
    __extends(InlineCardView, _super);
    function InlineCardView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dom = createInlineCardDOM();
        return _this;
    }
    return InlineCardView;
}(BaseCardView));
var BaseCard = /** @class */ (function (_super) {
    __extends(BaseCard, _super);
    function BaseCard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sylCard = true;
        _this.ViewMap = {};
        _this.layers = {};
        return _this;
    }
    return BaseCard;
}(Atom));
// * https://github.com/microsoft/TypeScript/issues/15607
var Card = /** @class */ (function (_super) {
    __extends(Card, _super);
    function Card() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.group = 'block';
        _this.isolating = true;
        _this.toDOM = function (node) { return createWrapperDOM(_this.tagName(node), node.attrs); };
        return _this;
    }
    Card.prototype.tagName = function (node) {
        return 'div';
    };
    Card = __decorate([
        defineMetadata(FLAG, FORMAT_TYPE.BLOCK_CARD)
    ], Card);
    return Card;
}(BaseCard));
Card.prototype.NodeView = BlockCardView;
var InlineCard = /** @class */ (function (_super) {
    __extends(InlineCard, _super);
    function InlineCard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.group = 'inline';
        _this.inline = true;
        _this.toDOM = function (node) { return createWrapperDOM(_this.tagName(node), node.attrs); };
        return _this;
    }
    InlineCard.prototype.tagName = function (node) {
        return 'span';
    };
    InlineCard = __decorate([
        defineMetadata(FLAG, FORMAT_TYPE.INLINE_CARD)
    ], InlineCard);
    return InlineCard;
}(BaseCard));
InlineCard.prototype.NodeView = InlineCardView;
// Deprecated
var configuration = function (_config) { return function (card) {
    var config = _config;
    var type = getMetadata(FLAG, card);
    if (!type || !isCardSchema(card)) {
        console.warn('config with not card type!');
        return card;
    }
    var Super = isInlineSchema(card) ? InlineAtom : BlockAtom;
    config = Object.assign(new Super(), config);
    // whether it is a sylCard, used to click to select node
    if (config.sylCard === undefined) {
        config.sylCard = true;
    }
    // if need to select node before you can drag. (default true)
    if (config.draggable === undefined) {
        config.draggable = true;
    }
    var meta = new SchemaMeta(type, config.name, config);
    defineMetadata(META, meta)(card);
    return card;
}; };
export { BaseCard, BaseCardView, BlockCardView, Card, configuration, InlineCard, InlineCardView };
//# sourceMappingURL=card.js.map